import { Card, CardHeader, CardTitle, CardContent } from "@/shared/ui/card.tsx";
import { Button } from "@/shared/ui/button.tsx";
import { Badge } from "@/shared/ui/badge.tsx";
import { ChevronDown, ChevronUp } from "lucide-react";
import { Table, TableHeader, TableRow, TableHead, TableBody } from "@/shared/ui/table.tsx";
import ImageRow from "./ImageRow";
import { EventGallery } from "../types";

const EventCard = ({
  event,
  isExpanded,
  toggleExpanded,
}: {
  event: EventGallery;
  isExpanded: boolean;
  toggleExpanded: () => void;
}) => {
  return (
    <Card className="w-full">
      <CardHeader onClick={toggleExpanded}>
        <div className="flex items-center justify-between">
          <div className="flex items-center gap-3">
            <Button variant="ghost" size="sm" className="p-1">
              {isExpanded ? (
                <ChevronUp className="w-4 h-4" />
              ) : (
                <ChevronDown className="w-4 h-4" />
              )}
            </Button>
            <CardTitle className="text-xl">{event.event_name}</CardTitle>
          </div>
          <Badge variant="outline">
            {event.images.length} image{event.images.length !== 1 ? "s" : ""}
          </Badge>
        </div>
      </CardHeader>

      {isExpanded && (
        <CardContent>
          <div className="rounded-md border">
            <Table>
              <TableHeader>
                <TableRow>
                  <TableHead className="w-[200px]">Image</TableHead>
                  <TableHead>Catalogue Item</TableHead>
                  <TableHead>Image Prompt</TableHead>
                  <TableHead className="w-[100px]">Posts</TableHead>
                  <TableHead className="w-[200px]">Actions</TableHead>
                </TableRow>
              </TableHeader>
              <TableBody>
                {event.images.map((image: any) => (
                  <ImageRow key={image.image_id} image={image} />
                ))}
              </TableBody>
            </Table>
          </div>
        </CardContent>
      )}
    </Card>
  );
};

export default EventCard;
